const updates = [
  { date: '07-31', title: '《流浪地球3》导演剪辑版独家上线平台', tag: '最新' },
  { date: '07-30', title: '西瓜视频免费专区新增200+部经典港片', tag: '上新' },
  { date: '07-29', title: '91在线视频「午夜剧场」频道全新改版', tag: '改版' },
  { date: '07-28', title: '暑期追剧季开启，热门剧集每日连更3集', tag: '活动' },
  { date: '07-27', title: '平台播放器升级，支持4K超清画质切换', tag: '升级' },
  { date: '07-26', title: '纪录片频道新增BBC Earth系列12部作品', tag: '上新' },
  { date: '07-25', title: '动漫频道「新番速递」板块正式上线', tag: '公告' },
  { date: '07-24', title: '综艺频道新增弹幕互动功能，边看边聊', tag: '功能' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-500/10 border border-secondary-500/20 mb-4">
            <span className="text-xs text-secondary-400 whitespace-nowrap">平台动态</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-400 max-w-xl mx-auto">
            关注69视频平台最新上架内容、功能更新与活动资讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="flex items-start gap-4 py-4 border-b border-background-200/40 last:border-b-0">
              <span className="text-xs text-foreground-500 font-mono whitespace-nowrap pt-0.5">{item.date}</span>
              <div className="flex-1 min-w-0 flex items-center gap-3">
                <span className="text-sm text-foreground-300">{item.title}</span>
              </div>
              <span className={`px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap flex-shrink-0 ${
                item.tag === '最新' ? 'bg-primary-500/20 text-primary-400' :
                item.tag === '上新' ? 'bg-accent-500/20 text-accent-400' :
                item.tag === '升级' ? 'bg-accent-500/20 text-accent-400' :
                'bg-secondary-500/20 text-secondary-400'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}